import React from "react"
import Layout from "../components/layout"
import { graphql } from "gatsby"
import IndustryComponent from "../components/industry/industry.component"

const Industry = () => {
  return (
    <Layout>
      <IndustryComponent />
    </Layout>
  )
}

export default Industry

export const query = graphql`
  query($language: String!) {
    locales: allLocale(filter: {language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
